const querySelector = document.querySelector.bind(document)
const { toString } = Object.prototype

export const $ = (selector: string | HTMLElement): HTMLElement => {
  return selector instanceof HTMLElement ? selector : querySelector(selector)
}

export const isType = (obj: object, types: string | Array<string> = ''): boolean => {
  const type = toString.call(obj).slice(8, -1).toLowerCase()
  return Array.isArray(types)
    ? types.map(t => t.toLowerCase()).includes(type)
    : types.toLowerCase() === type
}

export const clone = (obj: object) => JSON.parse(JSON.stringify(obj))

export const noop = function () {}

export function castArray <T> (value: T): Array<T> {
  return value == null ? [] : Array.isArray(value) ? value : [value]
}
